import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  checklists: [],
  checklist: null,
};

export const checklistSlice = createSlice({
  name: "checklist",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setChecklists: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.checklists = payload;
      if (payload.length > 0) {
        state.checklist = payload[0];
      } else {
        state.checklist = null;
      }
    },
    setChecklist: (state, { payload }) => {
      state.loading = false;
      state.error = null;
      state.checklist = payload;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export const { setLoading, setChecklists, setChecklist, setError } = checklistSlice.actions;

export default checklistSlice.reducer;

export const checklistsSelector = (state) => state.checklist;
